import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function MultipleCompetitorFilter({
selectedCompetitors = [],
setSelectedCompetitors,
setLoading,
month,
year,
isNps = false,
...rest
}) {
const authUser = localStorage.getItem("ag-authUser");
const user = JSON.parse(authUser);

const [competitors, setCompetitors] = useState([]);

useEffect(() => {
    if (!user.brandId) {
        Navigate("/");
        return;
    }

    getCompetitorsList();
}, []);

const getCompetitorsList = async () => {
    const brandId = user.brandId;

    let url = `/api/competitors?brandId=${brandId}&showNps=${isNps}`;

    if (month && year) {
        url = `/api/competitorsForBrandAttributes?brandId=${brandId}&month=${month}&year=${year}`;
    }

    try {
        setLoading(true);

        const response = await axios.get(url);

        setLoading(false);

        const result = response.data;

        if (result.success) {
            setCompetitors(result.data);

            // Get only actual competitors
            const availableCompetitors = result.data.filter(
                (competitor) =>
                    competitor.type === "Competitor" &&
                    competitor.name !== "None of these"
            );

            // Automatically select all competitors on page load
            setSelectedCompetitors(
                availableCompetitors.map((competitor) => competitor.id)
            );
        }
    } catch (err) {
        setLoading(false);
        console.log(err);

        Swal.fire(
            "Error in getting Competitiors List: " + err
        );
    }
};

const competitorList = competitors.filter(
    (competitor) =>
        competitor.type === "Competitor" &&
        competitor.name !== "None of these"
);

const handleCompetitorChange = (event) => {
    const competitorId = event.target.value;

    setSelectedCompetitors((prev) => {
        const isSelected = prev.some(
            (id) => parseInt(id) === parseInt(competitorId)
        );

        if (isSelected) {
            // Remove competitor
            return prev.filter(
                (id) => parseInt(id) !== parseInt(competitorId)
            );
        }

        // Add competitor
        return [...prev, competitorId];
    });
};

const handleSelectAll = () => {
    if (selectedCompetitors.length === competitorList.length) {
        // Deselect all
        setSelectedCompetitors([]);
    } else {
        // Select all
        setSelectedCompetitors(
            competitorList.map((competitor) => competitor.id)
        );
    }
};

const isAllSelected =
    competitorList.length > 0 &&
    selectedCompetitors.length === competitorList.length;

return (
    <div className="col-xl-12 col-lg-12 col-md-12 col-12">
        <div className="mb-15 filterRadioButton bankRadio competerBtn">
            {/* Self */}
            {competitors.map((competitor) => (
                <Fragment
                    key={`competitors${competitor.type}_${competitor.id}`}
                >
                    {competitor.type === "Self" ? (
                        <div className="col">
                            <input
                                type="radio"
                                className="btn-check"
                                name="self"
                                id={`self_competitor${competitor.id}`}
                                autoComplete="off"
                                defaultChecked
                                value={competitor.id}
                            />

                            <label
                                className="btn bg-orange-color fw-500"
                                htmlFor={`self_competitor${competitor.id}`}
                            >
                                {competitor.name}
                            </label>
                        </div>
                    ) : null}
                </Fragment>
            ))}

            {/* Individual Competitors */}
            {competitorList.map((competitor) => {
                const isSelected = selectedCompetitors.some(
                    (id) =>
                        parseInt(id) === parseInt(competitor.id)
                );

                return (
                    <div
                        className="col lightButton"
                        key={`competitor_${competitor.id}`}
                    >
                        <input
                            type="checkbox"
                            className="btn-check"
                            name="competitor"
                            id={`competitor${competitor.id}`}
                            autoComplete="off"
                            onChange={handleCompetitorChange}
                            checked={isSelected}
                            value={competitor.id}
                        />

                        <label
                            className={`btn ${
                                isSelected ? "div-bg" : ""
                            }`}
                            htmlFor={`competitor${competitor.id}`}
                        >
                            {competitor.name}
                        </label>
                    </div>
                );
            })}

            {/* All */}
            <div className="col lightButton">
                <input
                    type="checkbox"
                    className="btn-check"
                    name="competitor"
                    id="competitorAll"
                    autoComplete="off"
                    onChange={handleSelectAll}
                    checked={isAllSelected}
                />

                <label
                    className={`btn ${
                        isAllSelected ? "div-bg" : ""
                    }`}
                    htmlFor="competitorAll"
                >
                    All
                </label>
            </div>
        </div>
    </div>
);

}